import { Flex, Loader, Modal, TabList, Text } from "@coaching-culture/ui";
import { useMeasures, useRelationshipMeasures } from "queries/measures";
import { useState } from "react";
import { MeasureTrendChart } from "./MeasureTrendChart";

export type MeasuresTrendsModalProps = {
  relationshipId: string;
  onClose: () => void;
};

export const MeasuresTrendsModal = ({
  relationshipId,
  onClose,
}: MeasuresTrendsModalProps) => {
  const [measureIndex, setMeasureIndex] = useState(0);
  const measures = useMeasures();
  const data = useRelationshipMeasures(relationshipId);

  const isFetched = data.isFetched && measures.isFetched;

  const activeMeasure = measures.data?.[measureIndex];

  return (
    <Modal width={1000} minHeight={500} onClose={onClose} p={6} showCloseButton>
      {!isFetched ? (
        <Loader />
      ) : (
        <Flex flexDirection={"column"}>
          <Text as="h2" fontSize="page" fontWeight={600} mb={4}>
            {data.data.user.name} markers trend
          </Text>
          <TabList
            spread
            options={measures.data.map((x) => x.name)}
            activeIndex={measureIndex}
            onSelect={setMeasureIndex}
          />
          <MeasureTrendChart measure={activeMeasure} data={data.data} />
        </Flex>
      )}
    </Modal>
  );
};
